module.exports = __webpack_public_path__ + "static/media/add-file.90e10196.svg";